import { Component, Input, OnInit } from '@angular/core';
import { SharedCommonService } from 'app/shared/services/shared-common.service';

@Component({
  selector: 'appc-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss'],
  standalone: false,
})
export class BackToTopComponent implements OnInit {
  /**
   * The ID of the component we are going to scroll up to.
   * Please make sure to supply this parameter so that angular will know what
   *  element to scroll back to. 
   */
  @Input() scrollingElementId: string;
  scrollingElement: HTMLElement | null;
  hasScrolled: boolean;

  constructor(
    public sharedCommonService: SharedCommonService) {
  }

  ngOnInit() {
    this.scrollingElement = document.getElementById(this.scrollingElementId?.toString());
    const { scrollingElement } = this;
    if (scrollingElement) {
      scrollingElement.onscroll = () => {
        this.hasScrolled = scrollingElement.scrollTop > 0;
      }
    }
  }

  scrollToTop() {
    this.scrollingElement?.scroll(0, 0);
  }
}
